
  var productIDList = [];
  var form = document.querySelector(".ProductForm");
  var cartBtn = form.querySelector(".ProductForm__AddToCart ");
  var shopMoneyFormat = '';

 
  
   document.querySelector('body').addEventListener("productOptionsLoadedJS", function(e) {
       console.log("Product Options Loaded");
        const observeTarget = document.querySelector('.w3-product-options');
        const observeConfig = { attributes: false, childList: true, subtree: true };
      
        const oberveCallback = (mutationList, observer) => {
          console.log('selection changed');
          console.log(mutationList);
          var errs = document.querySelector('.product-options-errors');
          if (errs){
            errs.style.display = "none";
          }
        };
         const observer = new MutationObserver(oberveCallback);
        observer.observe(observeTarget, observeConfig);
     
        cartBtn.addEventListener("click", function(e){
          e.preventDefault();
          inventoryCheck(form, productIDList, true);
        })
   });

  
   document.querySelector('body').addEventListener("productOptionsPriceChangeJS", function(e) {
  
     var priceDiv = document.querySelector(".ProductMeta__Price");
     var titleDiv = document.querySelector(".pricing-info-header");
     titleDiv.textContent = "Additional Items:";
     
     var originalPrice = priceDiv.getAttribute("data-price");
     
     var totalDiv = document.querySelector(".pricing-info-total")
   
   	  var price = (e.detail[0] * 100);
      var container = e.detail[1];
      var products = e.detail[2];
      productIDList = products; //check inventory
      inventoryCheck(form, productIDList, false);
     
      var totalPrice = parseInt(originalPrice) + parseInt(price);
     
     totalDiv.textContent = "Total: " + Shopify.formatMoney(totalPrice, shopMoneyFormat);

     var productList = document.querySelector(".pricing-info-products");
     
     //remove existing products from additions box
     const extProducts = document.querySelectorAll('.pricing-info-product');
      extProducts.forEach(p => {
        p.remove();
      });
     
     //add back new products with price
     products.forEach(p => {
       	//product wrapper
       	 const newProductDiv = document.createElement("div");
         newProductDiv.classList.add("pricing-info-product");
       
         //product title
         const newProductTitleDiv = document.createElement("div");
         newProductDiv.classList.add("pricing-info-product-title");
         const newContent = document.createTextNode(p.title);
         newProductTitleDiv.appendChild(newContent);
       
       	//price span
       	const newProductPrice = document.createElement("span");
       	newProductPrice.classList.add("pricing-info-product-price");
       
       //get selected variant price
       var variants = p.variants;
       p.variants.forEach(v => {
         if (v.id == p.variant_id){
           newProductPrice.innerHTML = " - " + Shopify.formatMoney(v.price, shopMoneyFormat) ;
       
       		//add price to product title div
       		newProductTitleDiv.appendChild(newProductPrice);
         }
            
       });
		
       
       //add product title div to product
        newProductDiv.appendChild(newProductTitleDiv);

		//add product to list of prodicts
        productList.appendChild(newProductDiv);
       
      });
     
   //debug
   //console.log(price);
   //console.log(container);
   //console.log(products);
 
});

  
     function inventoryCheck(form, products, isSubmit){
        var outofstockTitle = [];
        var spanStockMsg = form.querySelector("#options-stock-msg");
        if(!spanStockMsg){
           spanStockMsg = document.createElement("div");
           spanStockMsg.id = "options-stock-msg";
           cartBtn.parentElement.insertBefore(spanStockMsg, cartBtn);

        }
       
        var ajaxRequests = [];

        outofstock = false;
        spanStockMsg.style.display = "block";

        cartBtn.style.display = "none";
        spanStockMsg.innerText = "Checking inventory...";
        
        if(products == null) {
          products = [];
        }

        $.each(products, function(i, product) {
          var req = $.ajax({
            method: "GET",
            url: "/products/" + product.handle + ".js",
            dataType: "json",
            success: function (shopifyProduct) {
              var variant = getVariant(product.variantID);
              var productTitle = product.title;
              if(!shopifyProduct.available || variant == null) {
                outofstock = true;
                outofstockTitle.push(productTitle);
              }
              if(variant != null) {
                if(!variant.available) {
                  outofstock = true;
                  outofstockTitle.push(variant.title);
                }
              }
              function getVariant(id) {
                var returnVariant = null;
                $.each(shopifyProduct.variants, function(i, variant) {
                  if(variant.id == id) {
                    returnVariant = variant;
                    return;
                  }
                });
                return returnVariant;
              }
            }
          });
          ajaxRequests.push(req);
        });

        $.when.apply($, ajaxRequests).then(function() {
          if(outofstock) {
            cartBtn.innerHTML = "<span>Unavailable</span>";
            cartBtn.setAttribute("disabled", "disabled");
            cartBtn.classList.add("options-disabled");
            cartBtn.style.display = "flex";
            
            if (outofstockTitle.length == 1){
              spanStockMsg.innerHTML = "<strong>This product is out of stock</strong>:<br>" + outofstockTitle + " ";
            } else {
              spanStockMsg.innerHTML = "<strong>These products are out of stock</strong>:<br>" + outofstockTitle.join(", ") + " ";
            }
          } else {
            spanStockMsg.style.display = "none"
            cartBtn.innerHTML = "<span>ADD TO CART</span>";
            cartBtn.removeAttribute("disabled");
            cartBtn.classList.remove("options-disabled");
             cartBtn.style.display = "flex";
            if (isSubmit){
              window.poSubmitAddToCart();
            }
          }
        });
      }
